import key from 'weak-key';
import { Container, Row, Col } from '@geberit/gdds';

// style
import styles from './lead-module.module.scss';

// constants
import { Formats } from 'components/ContentElementsGdds/headline/headlines.types';

// components
import { ModuleBox } from './module-box';
import { Headline } from 'components/ContentElementsGdds/headline/headline';

// utils
import { buildSize, gridSizes } from 'utils/gridSize';
import { useSectionId } from 'utils/hooks/use-section-id';
import { previewId } from 'utils/preview-id';
import { useXy } from 'utils/hooks/use-xy';

// different grids for different amount of elements
const GRID_SIZE_MODULES = {
  1: [4, 8, 8],
  2: [4, 8, 8],
  3: [4, 8, 12],
  4: [4, 8, 12],
};

type LeadModuleProps = {
  contentIndex: number;
  titleInAnchor: boolean;
  anchor: string;
  title: string;
  subtitle: string;
  text: string;
  modules: any[];
  isChild?: boolean;
};

export function LeadModule({
  contentIndex,
  titleInAnchor,
  anchor,
  title,
  subtitle,
  text,
  modules,
  isChild = false,
}: Readonly<LeadModuleProps>) {
  const sectionId = useSectionId(title, anchor, titleInAnchor, contentIndex);
  const isXy = useXy();
  const textHeadlineTag = isXy ? (isChild ? Formats.h5 : Formats.h3) : undefined;

  return (
    <section className={styles.sectionWrapper} id={sectionId}>
      <Container maxContentWidth={buildSize(gridSizes.gddsFullGrid)}>
        <Headline
          title={title}
          subtitle={subtitle}
          text={text}
          tag="h2"
          textHeadlineTag={textHeadlineTag}
        />
        <Row>
          <Col size={GRID_SIZE_MODULES[modules.length]}>
            <div
              className={
                styles[
                  ['', 'one-of-one', 'one-of-two', 'one-of-three', 'one-of-four'][modules.length]
                ]
              }
              {...previewId('#st_leadModules')}
            >
              {modules.map((moduleItem, itemIndex) => (
                <ModuleBox
                  key={key(moduleItem)}
                  headline={moduleItem.headline}
                  text={moduleItem.text}
                  itemIndex={itemIndex}
                  itemsSize={modules.length}
                  isChild={isChild}
                  {...moduleItem}
                />
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
